import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useGetAbstractListApi } from '@/api/conference';
import TablePagination from '@/components/common/Pagination/TablePagination';
import ArrowLeftIcon from '@/components/Icon/ArrowLeftIcon';
import { CONF_TITLE } from '@/constants/menu';

import * as S from './style';

const AbstractConfirm = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const presentationOptions = t('society.abstract.presentations', { returnObjects: true }) as { value: string; label: string }[];
	const oralPresentationValue = presentationOptions[0]?.value ?? '';

	const [page, setPage] = useState(1);

	const { data: abstractListData } = useGetAbstractListApi({
		conference_name: CONF_TITLE,
		page: page,
		row: 10,
	});

	const handleBackButton = () => {
		navigate(-1);
	};

	return (
		<S.Container noData={abstractListData?.abstract?.length === 0}>
			<S.BackButton onClick={handleBackButton}>
				<ArrowLeftIcon iconColor="#01337D" width="16" height="16" />
				<span>{t('society.confirm.back')}</span>
			</S.BackButton>
			{abstractListData?.abstract?.length !== 0 ? (
				<TablePagination activePage={page} totalItems={abstractListData?.total_count} onChange={(page) => setPage(page)}>
					<S.TableBox>
						{abstractListData?.abstract?.map((item, index) => (
							<S.TableItem key={index}>
								<S.TableContent>
									<p className="date">{item.abstract_enrollment_date}</p>
									<div className="abstract-info">
										<div>
											<span>{t(item.abstract_presentation)}</span>
											{item.abstract_presentation === oralPresentationValue && (
												<S.Badge status={item.abstract_approve === 'approve' ? 'approve' : 'reject'}>
													{item.abstract_approve === 'approve' ? t('society.confirm.abstract.approved') : t('society.confirm.abstract.rejected')}
												</S.Badge>
											)}
										</div>
										<p>{t(item.abstract_division)}</p>
									</div>
									<p>{t(item.abstract_conference_name)}</p>
								</S.TableContent>
								<S.Button href={item.file_path} target="_blank" rel="noopener noreferrer">
									{t('society.confirm.abstract.button')}
								</S.Button>
							</S.TableItem>
						))}
					</S.TableBox>
				</TablePagination>
			) : (
				<S.NoData>{t('society.confirm.noData')}</S.NoData>
			)}
		</S.Container>
	);
};
export default AbstractConfirm;
